import { createFileRoute } from '@tanstack/react-router';
import { JourneysAutomationTestsHandoff } from '@/pages/workspaces/automations/[campaignId]/tests/routing';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/tests/$actionId',
)({
  component: JourneysAutomationTestsHandoff,
});
